<template>
  <div>
    <VueCtkDateTimePicker
      v-model="date"
      no-label
      minute-interval="10"
      :label="label"
      format="DD-MM-YYYY HH:mm"
      formatted="DD-MM-YYYY HH:mm"
    />
  </div>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";
import { Vue, Component, Watch } from "vue-property-decorator";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";

// source: https://github.com/chronotruck/vue-ctk-date-time-picker
// Demo:  https://chronotruck.github.io/vue-ctk-date-time-picker/

@Component({
  components: {
    VueCtkDateTimePicker,
  },
  name: "DatePicker",
  props: {
    value: {
      default: "",
    },
    label: {
      default: "Date & Time",
    },
    timestamp: {
      default: true,
    },
    disabled: {
      default: false,
    },
    dense: {
      default: false,
    },
    timezone: {
      default: null,
    },
    offset: {
      default: null,
    },
    autoSelect: {
      default: false,
    },
    rules: {
      default: () => [],
    },
  },
})
export default class DatePicker extends (Vue, Themeable) {
  dateFormatted = null;
  menu1 = false;
  date = null;
  time = null;
  timezoneOffset = new Date().getTimezoneOffset() * 60;

  mounted() {
    if (this.value > 100) {
      this.date = this.getDate(this.value + this.timezoneOffset);
    }
  }

  @Watch("offset")
  onOffsetChange(val) {
    this.timezoneOffset =
      val == null ? new Date().getTimezoneOffset() * 60 : val;
  }

  @Watch("date", { immediate: true })
  onDateChange(val, oldValue) {
    if (val != null && val.length > 15)
      this.$emit("input", this.stringToTimestamp(val));
    else this.$emit("input", null);
  }

  @Watch("value", { immediate: true })
  onValueChange(value, oldValue) {
    if (this.value > 100) {
      this.date = this.getDate(this.value + this.timezoneOffset);
    }
  }

  getDate(value) {
    if (value == null) {
      return null;
    }
    value = value * 1000 - this.timezoneOffset * 1000;
    this.time = this.$moment(value).toISOString().substring(10);
    return this.$moment(value).format("DD-MM-YYYY HH:mm");
  }

  stringToTimestamp(str) {
    const dt =
      str.substring(6, 10) +
      "-" +
      str.substring(3, 5) +
      "-" +
      str.substring(0, 2) +
      "T" +
      str.substring(11, 13) +
      ":" +
      str.substring(14, 16);
    const a = this.$moment(dt + ":00.000Z").format("X");
    return parseInt(a) + this.timezoneOffset;
  }
}
</script>

<style>
.field-input[data-v-5b500588] {
  border-top: none;
  border-left: none;
  border-right: none;
  border-radius: 0;
}
</style>
